// extracted by mini-css-extract-plugin
export default {"career-info-content":"CareerInfoContent_career-info-content__Z0oDf","info-card":"CareerInfoContent_info-card__fNT5O"};